module.exports = __webpack_public_path__ + "static/grummies-are-good-for-you-ac7ed26d8c1b5dab625104e9d25a11b9.svg";